const languages = ['en', 'cs']

export default languages
